let envConfig = null;

/**
 * Return an object of environment variables for the application.
 * These should be defined in the applications public as a env.json file prior
 * to deployment.
 *
 * @returns {Promise<null>}
 */
export default async function getEnv() {
  if (!envConfig) {
    const response = await fetch(`${process.env.BASE_URL}env.json`); // eslint-disable-line no-undef

    envConfig = await response.json();
  }

  return envConfig;
}
export function setEnv(env) {
  if (!env) {
    return;
  }
  envConfig = { ...env };
}
